export const blockchairMethods = {
    getBalance: async (client, baseUrl, { address }) => {
        const apiUrl = `${baseUrl}/addresses/balances/?addresses=${address}`;
        const response = (await client.request({
            url: apiUrl,
            fetchOptions: { method: 'GET' },
        }));
        if (response.context?.code !== 200) {
            return {
                error: {
                    code: response.context?.code,
                    message: response.context?.error,
                },
            };
        }
        return {
            result: BigInt(response.data[address]),
        };
    },
};
//# sourceMappingURL=blockchair.js.map